<div class="login-screen">
    <div class="row m-0">
        <div class="col-lg-7 p-0">
            <div class="contentLogin">
                <div class="logo-header">
                    <img src="assets/images/logo.svg" class="img-fluid" alt="" srcset="">
                    <h5 class="m-0">{{'DONT_HAVE_ACCOUNT' | translate }} &nbsp;<a href="#" class="fw-medium">{{'SIGN_IN' | translate }}!</a></h5>
                </div>
                <div class="loginbox">
                    <h2 class="text-left mb-4  fw-light">{{'ENTER_CODE' | translate }}</h2>
                    <h5 class="text-left  fw-normal">{{'ENTER_CODE_VERFICATION_DESC' | translate }} {{maskedEmail}}</h5>
                    <h5 class="text-danger">{{'CHECK_SPAM_MESSAGE' | translate}}</h5>
                    <form class="login-form" [formGroup]="verifyOtpForm" (ngSubmit)="form.form.valid && onVerifyOtp($event)" #form="ngForm">
                        <!-- <div class="enter-code my-3">
                            <div class="box">3</div>
                            <div class="box">5</div>
                            <div class="box">9</div>
                            <div class="box">-</div>
                            <div class="box">-</div>
                            <div class="box">-</div>
                        </div> -->
                        <div class="form-group my-3 d-flex align-items-center  gap-4 text-center otp-bar flex-nowrap whitespace-nowrap">
                            <ng-otp-input #ngOtpInput [config]="config" formControlName="otp"></ng-otp-input>
                        </div>
                        <mat-error class="text-danger" *ngIf="form.submitted && verifyOtpForm.controls['otp'].errors?.['required']">
                            {{'OTP_REQUIRED_MSG' | translate }}
                        </mat-error>
                        <!-- <h5 class="m-0  fw-normal">Remaining Attempts 1/4</h5> -->
                        <h5 class="text-left fw-normal fw-bold mt-2">{{'REMAINING_ATTEMPTS' | translate }} {{remainagAttemps}} Out Of 4</h5>
                        <button mat-flat-button color="primary" class="my-3 w-100">{{'VERIFY_CODE' | translate }}</button>
                        <div class="d-flex align-items-center justify-content-between w-100 gap-3 mt-2">
                            <p class="m-0">
                                {{'HAVENT_GOT_EMAIL' | translate }}
                                <a href="javascript:void(0)" class="text-decoration-underline" (click)="resendCode()">{{'RESEND_CODE' | translate }}</a>
                            </p>
                            <!-- <a href="#" class="text-decoration-underline text-danger">Report</a> -->
                        </div>
                    </form>
                </div>
            </div>

        </div>
        <!-- <div class="col-lg-5 p-0" >
            <div class="recoverimage-height image-height">
                <p>&nbsp;</p>
            </div>

        </div> -->
        <div class="col-lg-5 p-0">
            <div [ngClass]="getBackgroundClass()">
                <p>&nbsp;</p>
            </div>

        </div>
       
    </div>
</div>